import Swal from 'sweetalert2';
import { t } from 'i18next';

export type CascadeChoice = 'confirm' | 'cancel';

function showConfirmCascade(message: string, darkMode?: boolean): Promise<CascadeChoice> {
    return Swal.fire({
        title: `<h3 style="color: #ddaf16; margin-top: -4%;"><strong>${t('general.atencao')}</strong></h3>`,
        html: `<h3>${message}</h3>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: t('general.sim'),
        cancelButtonText: t('general.cancelar'),
        confirmButtonColor: '#83c444',
        cancelButtonColor: darkMode ? '#405568' : '#252527',
        reverseButtons: true,
        background: darkMode ? '#141c2b' : '#ffffff',
        color: darkMode ? '#ffffff' : '#333333',
    }).then((result) => {
        if (result.isConfirmed) return 'confirm';
        return 'cancel';
    });
}

export default showConfirmCascade;
